import React, { useEffect } from 'react'
import { Text, View } from 'styles/reactnative'

import { IconInfoSquare } from '@tabler/icons'
import { Button, Input, Popover, Select, Space } from 'antd'
import { buttonlist } from 'app/components/AdminUserModal/UserInfoTabs'
import { APPNAME } from 'app/constants/APIKEYS'
import { column_log_page } from '../../../components/AdminUserModal/UserInfoTabs/column_log_page'
import TableAPI from '../../../components/TableAPI'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { useUserList } from '../../../hooks/user/userlist'


const AdminActivityHistory = ({ title, type }: any) => {
	const queryParams = new URLSearchParams(window.location.search)
	const id = queryParams.get('userid')

	const [coinglobal, setCoinglobal] = React.useState('G')

	const [search, setSearch] = React.useState(id || '')
	const { usertype1 } = useUserList()
	const [group, setGroup] = React.useState('*')
	const { type1 } = useUserGroup()
	const [level, setLevel] = React.useState<any>('1')

	const [logfilter, setLogfilter] = React.useState<any>('')

	const [defaultmaxData, setDefaultmaxData] = React.useState(100)

	const [log, setLog] = React.useState<any>(new Set([]))

	const [url, setUrl] = React.useState(`/admin/history/users?group=*&coinglobal=G&log=&level=1&t=`)

	useEffect(() => {
		if (log.size == 0) {
			setLogfilter('')
		} else {
			const temp = Array.from(log).map((key: any) => buttonlist[key]).flat()
			setLogfilter(temp.join(','))
		}
	}, [log])

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Space.Compact direction="horizontal">
					<Button
						type="default"
						size="small"
						danger={coinglobal === '*'}
						onClick={() => setCoinglobal('*')}>
						전체
					</Button>
					{["THEBIT"].includes(APPNAME) && (
						<>

							<Button
								type="default"
								size="small"
								danger={coinglobal === 'C'}
								onClick={() => setCoinglobal('C')}>
								코인
							</Button>
							<Button
								type="default"
								size="small"
								danger={coinglobal === 'G'}
								onClick={() => setCoinglobal('G')}>
								글로벌
							</Button></>
					)}

					<Select
						defaultValue={'*'}
						onChange={e => {
							setGroup(e)
						}}
						value={group}
						style={{ width: '100%', minWidth: 150 }}
						options={[
							{ value: '*', label: '그룹전체' },
							...(type1 || []),
						]}
					/>
					<Select
						defaultValue={'1'}
						onChange={e => {
							setLevel(e)
						}}
						value={level}
						style={{ width: '100%', minWidth: 120 }}
						options={[
							{ value: '*', label: '등급전체' },
							{ value: '1', label: '일반회원' },
							{ value: '6', label: '모의회원' },
							{ value: '-9', label: '블랙' },
							{ value: '-10', label: '모의블랙' },
						]}
					/>
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setSearch(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={search}
							onChange={e => {
								setSearch(e.target.value)
							}}
						/>
					</Popover>

					<Button type={log.size == 0 ? 'primary' : 'default'} danger size="small" 
						style={{marginLeft: 10}}
					onClick={() => setLog(new Set([]))}>전체로그</Button>
					{buttonlist && Object.keys(buttonlist)?.map((key) => (
						<Button type={log?.has(key) ? 'primary' : 'default'} size="small" onClick={() => {
							if (log?.has(key)) {
								setLog((prev: any) => { const temp = new Set(prev); temp.delete(key); return temp; })
							} else {
								setLog((prev: any) => { const temp = new Set(prev); temp.add(key); return temp; })
							}

						}}>{key}</Button>
					))}
				</Space.Compact>
			</View>



			<Space.Compact direction="horizontal" style={{
				flexDirection: 'row',
				backgroundColor: 'white',
				width: '100%',
				alignItems: 'center',
				justifyContent: 'center',
			}} size='small'>

				<Space style={{
					border: '1px solid #ccc',
					padding: 5,
					borderRadius: 5,
				}}>
					기본 조회갯수
					<Select defaultValue={defaultmaxData} onChange={e => setDefaultmaxData(e)} style={{ width: 120 }}>
						<Select.Option value={100}>100</Select.Option>
						<Select.Option value={500}>500</Select.Option>
						<Select.Option value={1000}>1000</Select.Option>
						<Select.Option value={10000}>10000</Select.Option>
					</Select>

					<Button onClick={() => setUrl(`/admin/history/users?group=${group}&coinglobal=${coinglobal}&log=${logfilter}&level=${level}&${search ? 'type=user_id&searchWord=' + search : 't='}`)} type="primary" danger > 조회</Button>
				</Space>
			</Space.Compact>


			<View style={{
				height: 10, borderBottom:
					'1px solid #333', width: '100%', marginBottom: 10
			}} />

			{!url ? (
				<Text>조회할 내용을 선택해주세요</Text>
			) : (
				<TableAPI
					title={title}
					columns={column_log_page}
					datesearch={true}
					defaultMaxData={100}
					usermodal={true}
					height={'default'}
					apikey={url}
				/>

			)}
		</View >
	)
}

export default React.memo(AdminActivityHistory)
